import '@babel/polyfill' // suporte ao cliente de websocket do AdonisJS
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import FarsoftKit from './plugins/farsoft.kit'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import '@/plugins/'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import '@/plugins/vue-cookies'
import ws from '@adonisjs/websocket-client' // Cliente de websockets

Vue.use(PerfectScrollbar)

Vue.use(FarsoftKit)

// registra o plugin de websockets
const wsVuePlugin = function (Vue, url, options) {
  Vue.prototype.$ws = ws(url, options)
}
Vue.use(wsVuePlugin, process.env.VUE_APP_WS_ENDPOINT, { debug: false })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
